/* Library ▸ Canva designs (desktop CanvaIframeTab): the same account picker and designs as Web to poster. */
import { useState } from 'react';
import { Card, EmptyState, Skeleton } from '../../ui/index.jsx';
import { CanvaAccountPicker, CanvaDesigns, useCanvaAccounts } from './canva.jsx';
import { useTranslation } from 'react-i18next';

export default function LibraryCanva() {
  const { t } = useTranslation('bv');
  const { accounts, off, reload } = useCanvaAccounts();
  const [openId, setOpenId] = useState(() => { try { return localStorage.getItem('bv.canva.account'); } catch { return null; } });
  if (!accounts) return <Skeleton height={180} radius={24} />;
  if (off) return <Card><EmptyState icon="canva" title={t('canva.off.title')}>{t('canva.off.body')}</EmptyState></Card>;
  const account = openId ? accounts.find((a) => a.id === openId && a.signedIn) : null;
  if (account) return <CanvaDesigns account={account} onSwitch={() => setOpenId(null)} onRelink={() => { setOpenId(null); reload(); }} />;
  return <CanvaAccountPicker accounts={accounts} returnPath="/library?tab=canva" onChanged={reload}
    onOpen={(a) => { try { localStorage.setItem('bv.canva.account', a.id); } catch { /* blocked */ } setOpenId(a.id); }} />;
}
